var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        { staticClass: "shell", attrs: { id: "app" } },
        [
          !_vm.inFrame
            ? _c("header-component", { attrs: { params: "route: route" } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-area", class: { embedded: _vm.inFrame } },
            [_c("router-view")],
            1
          ),
          _vm._v(" "),
          !_vm.inFrame ? _c("footer-component") : _vm._e(),
          _vm._v(" "),
          _vm.spinnerShown
            ? _c(
                "div",
                { staticClass: "spinner-container" },
                [_c("spinner", { attrs: { active: true } })],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c01f6260", { render: render, staticRenderFns: staticRenderFns })
  }
}